import { SET_FILED_ANNOUNCEMENTS, SET_NOT_FILED_ANNOUNCEMENTS } from "./actions"

const initialState = {
  filedAnnouncements: null,
  notFiledAnnouncements: null,
}

const filedAnnouncementsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_FILED_ANNOUNCEMENTS:
      return {
        ...state,
        filedAnnouncements: action.payload,
      }
    case SET_NOT_FILED_ANNOUNCEMENTS:
      return {
        ...state,
        notFiledAnnouncements: action.payload,
      }
    default:
      return state
  }
}

export default filedAnnouncementsReducer
